import React from "react";
import CodeGenarator from "./../CodeComponent/codeGenerator";
import CopyClip from "./copyClip";
import PlayComponents from "./playComponent";
import { clearDrawer, drawer } from "../Menu/drawer-bootstrap";
import $ from "jquery";
import {
  InlineCalender,
  InlineCalenderVertical,
  MonthCalender,
  YearCalender,
  TenYearCalender,
  FullCalender,
  FullCalenderVertical
} from "react-inline-calender";

export default class Main2Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      e23: {
        mainBodyStyle: {
          height: "350px"
        },
        titleStyle: {
          height: "50px",
          color: "#eeeeee"
        },
        headerCalenderItemStyle: {
          color: "#3d0e1e"
        },
        headerCalenderStyle: {
          //   width: "75px",
          background: "#fff4e4"
        },
        rowCalenderStyle: {
          //   width: "50px"
        },
        footerStyle: {
          height: "50px"
        },
        afterTodayStyle: {
          color: "#eeeeee",
          boxShadow: "inset 0 0 10px #311d3f",
          background: "#88304e",
          transition: "all 1s"
        },
        todayStyle: {
          color: "#eeeeee",
          background: "#522546",
          boxShadow: "0 0 5px #eeeeee",
          transition: " all 1s"
        },
        beforeTodayStyle: {
          background: "#eeeeee",
          boxShadow: "inset 0 0 10px #88304e",
          color: "#88304e",
          transition: "all 1s"
        }
      },
      e2: {
        arrowRightColor: {
          color: "#88304e"
        },
        arrowLeftColor: {
          color: "#88304e"
        },
        mainBodyStyle: {
          width: "300px",
          padding: "15px"
        },
        titleStyle: {
          height: "40px",
          color: "#88304e"
        },
        headerCalenderStyle: {
          height: "40px"
        },
        headerCalenderItemStyle: {
          color: "#88304e"
        },
        rowCalenderStyle: {
          height: "50px"
        },
        footerStyle: {
          height: "20px",

          color: "#88304e"
        },
        afterTodayStyle: {
          color: "#eeeeee",
          boxShadow: "inset 0 0 10px #311d3f",
          background: "#88304e",
          transition: "all 1s"
        },
        todayStyle: {
          color: "#eeeeee",
          background: "#522546",
          boxShadow: "0 0 5px #eeeeee",
          transition: " all 1s"
        },
        beforeTodayStyle: {
          background: "#eeeeee",
          boxShadow: "inset 0 0 10px #88304e",
          color: "#88304e",
          transition: "all 1s"
        },
        todayButtonStyle: {
          color: "#88304e"
        },
        showSelectedValueStyle: {
          display: "flex",
          alignItems: "center",
          color: "#88304e"
        }
      },
      e1: {
        arrowRightColor: {
          color: "#88304e"
        },
        arrowLeftColor: {
          color: "#88304e"
        },
        mainBodyStyle: {
          width: "300px",
          background: "#eaffd0",
          border: "2px solid #311d3f",
          borderRadius: "5px",
          padding: "15px"
        },
        titleStyle: {
          height: "40px",
          marginBottom: "5px",
          color: "#88304e"
        },
        headerCalenderStyle: {
          height: "40px",
          color: "#fff",
          background: "#88304e",
          margin: "0 -14.5px"
        },
        rowCalenderStyle: {
          height: "50px",
          margin: "0 -14px"
        },
        footerStyle: {
          height: "20px",
          color: "#88304e"
        },
        afterTodayStyle: {
          color: "#eeeeee",
          boxShadow: "inset 0 0 10px #311d3f",
          background: "#88304e",
          transition: "all 1s"
        },
        todayStyle: {
          color: "#eeeeee",
          background: "#522546",
          boxShadow: "0 0 5px #eeeeee",
          transition: " all 1s"
        },
        beforeTodayStyle: {
          background: "#eeeeee",
          boxShadow: "inset 0 0 10px #88304e",
          color: "#88304e",
          transition: "all 1s"
        },
        todayButtonStyle: {
          color: "#88304e"
        },
        showSelectedValueStyle: {
          display: "flex",
          alignItems: "center",
          color: "#88304e"
        },
        moveAction: {
          action: ""
        }
      }
    };
  }

  componentDidMount() {
    this.props.showMenu();
    // $(".menu-keeper").prepend(``)
  }
  componentWillUnmount() {
    this.props.deleteMenu();
    $(document).ready(function() {
      drawer({
        exitResizeing: false,
        withNavItemBootstrap: false,
        withNavbarBrandBootstrap: false,
        withDropDownBotstrap: false,
        customJqueryElement: $(".nav .nav-item").clone(true),
        customHeadDrawer: "<div></div>",
        headerStyle: {},
        class: {
          showButton: "openDrawer"
        },
        defualtStylesPosition: 8
      });
    });
  }

  render() {
    let stringCode5 = `
     import React from "react";
     import "bootstrap/dist/css/bootstrap.css";
     import {
        InlineCalender
     } from "react-inline-calender";
     class Sample extends React.Component {
       constructor(props) {
         super(props);
       }
       render() {
         return (
           <div className="container">
             <div className="row">
               <div className="offset-3 col-6">
                 <InlineCalender></InlineCalender>
               </div>
             </div>
           </div>
         );
       }
     }
      
     export default Sample;
     `;

    let stringCode6 = `

        import React from "react";
        import "bootstrap/dist/css/bootstrap.css";
        import {
           InlineCalender
        } from "react-inline-calender";
        class Sample extends React.Component {
          constructor(props) {
            super(props);
          }
          render() {
            return (
              <div className="container">
                <div className="row">
                  <div className="offset-3 col-6">
                    <InlineCalender></InlineCalender>
                  </div>
                </div>
              </div>
            );
          }
        }
         
        export default Sample;
        `;

    let stringCode7 = `
        import React from "react";
        import "bootstrap/dist/css/bootstrap.css";
        import {
           InlineCalender
        } from "react-inline-calender";
        class Sample extends React.Component {
          constructor(props) {
            super(props);
            this.state={
               e1: {
                   arrowRightColor: {
                     color: "#88304e"
                   },
                   arrowLeftColor: {
                     color: "#88304e"
                   },
                   mainBodyStyle: {
                   width: "300px",
                   background: "#eaffd0",
                   border: "2px solid #311d3f",
                   borderRadius: "5px",
                   padding: "15px"
                   },
                   titleStyle: {
                   height: "40px",
                   marginBottom: "5px",
                   color: "#88304e"
                   },
                   headerCalenderStyle: {
                   height: "40px",
                   color: "#fff",
                   background: "#88304e",
                   margin: "0 -14.5px"
                   },
                   rowCalenderStyle: {
                   height: "50px",
                   margin: "0 -14px"
                   },
                   footerStyle: {
                   height: "20px",
                   color: "#88304e"
                   },
                   afterTodayStyle: {
                   color: "#eeeeee",
                   boxShadow: "inset 0 0 10px #311d3f",
                   background: "#88304e",
                   transition: "all 1s"
                   },
                   todayStyle: {
                   color: "#eeeeee",
                   background: "#522546",
                   boxShadow: "0 0 5px #eeeeee",
                   transition: " all 1s"
                   },
                   beforeTodayStyle: {
                   background: "#eeeeee",
                   boxShadow: "inset 0 0 10px #88304e",
                   color: "#88304e",
                   transition: "all 1s"
                   },
                   todayButtonStyle: {
                   color: "#88304e"
                   },
                   showSelectedValueStyle: {
                   display: "flex",
                   alignItems: "center",
                   color: "#88304e"
                   }
               }
           }
          }
          render() {
            return (
              <div className="container">
                <div className="row">
                  <div className="offset-3 col-6">
                       <InlineCalender
                       arrowLeftStyle={this.state.e1.arrowLeftColor}
                       arrowRightStyle={this.state.e1.arrowRightColor}
                       useRaitoSizing={false}
                       mainBodyStyle={this.state.e1.mainBodyStyle}
                       afterTodayStyle={this.state.e1.afterTodayStyle}
                       titleStyle={this.state.e1.titleStyle}
                       beforeTodayStyle={this.state.e1.beforeTodayStyle}
                       rowCalenderStyle={this.state.e1.rowCalenderStyle}
                       headerCalenderStyle={this.state.e1.headerCalenderStyle}
                       footerStyle={this.state.e1.footerStyle}
                       todayStyle={this.state.e1.todayStyle}
                       todayButtonStyle={this.state.e1.todayButtonStyle}
                       showSelectedValueStyle={this.state.e1.showSelectedValueStyle}
                       />
                  </div>
                </div>
              </div>
            );
          }
        }
         
        export default Sample;
        `;

    let stringCode8 = `
        import React from "react";
        import "bootstrap/dist/css/bootstrap.css";
        import {
           InlineCalender
        } from "react-inline-calender";
        class Sample extends React.Component {
          constructor(props) {
            super(props);
            this.state={
                e2: {
                    arrowRightColor: {
                        color: "#88304e"
                      },
                      arrowLeftColor: {
                        color: "#88304e"
                      },
                    mainBodyStyle: {
                      width: "300px",
                      padding: "15px"
                    },
                    titleStyle: {
                      height: "40px",
                      color: "#88304e"
                    },
                    headerCalenderStyle: {
                      height: "40px"
                    },
                    headerCalenderItemStyle: {
                      color: "#88304e"
                    },
                    rowCalenderStyle: {
                      height: "50px"
                    },
                    footerStyle: {
                      height: "20px",
    
                      color: "#88304e"
                    },
                    afterTodayStyle: {
                      color: "#eeeeee",
                      boxShadow: "inset 0 0 10px #311d3f",
                      background: "#88304e",
                      transition: "all 1s"
                    },
                    todayStyle: {
                      color: "#eeeeee",
                      background: "#522546",
                      boxShadow: "0 0 5px #eeeeee",
                      transition: " all 1s"
                    },
                    beforeTodayStyle: {
                      background: "#eeeeee",
                      boxShadow: "inset 0 0 10px #88304e",
                      color: "#88304e",
                      transition: "all 1s"
                    },
                    todayButtonStyle: {
                      color: "#88304e"
                    },
                    showSelectedValueStyle: {
                      display: "flex",
                      alignItems: "center",
                      color: "#88304e"
                    }
                  }
           }
          }
          render() {
            return (
              <div className="container">
                <div className="row">
                  <div className="offset-3 col-6">
                    <InlineCalender
                    useRaitoSizing={false}
                    arrowLeftStyle={this.state.e2.arrowLeftColor}
                    arrowRightStyle={this.state.e2.arrowRightColor}
                    mainBodyStyle={this.state.e2.mainBodyStyle}
                    afterTodayStyle={this.state.e2.afterTodayStyle}
                    titleStyle={this.state.e2.titleStyle}
                    beforeTodayStyle={this.state.e2.beforeTodayStyle}
                    rowCalenderStyle={this.state.e2.rowCalenderStyle}
                    headerCalenderStyle={this.state.e2.headerCalenderStyle}
                    footerStyle={this.state.e2.footerStyle}
                    todayStyle={this.state.e2.todayStyle}
                    todayButtonStyle={this.state.e2.todayButtonStyle}
                    showSelectedValueStyle={this.state.e2.showSelectedValueStyle}
                    headerCalenderItemStyle={this.state.e2.headerCalenderItemStyle}
                    />
                  </div>
                </div>
              </div>
            );
          }
        }
         
        export default Sample;
        `;
    let stringCode9 = `
    import React from "react";
    import "bootstrap/dist/css/bootstrap.css";
    import {
        InlineCalenderVertical
    } from "react-inline-calender";
    class Sample extends React.Component {
      constructor(props) {
        super(props);
        this.state={
            e23: {
                mainBodyStyle: {
                  height: "350px"
                },
                titleStyle: {
                  height: "50px",
                  color: "#eeeeee"
                },
                headerCalenderItemStyle: {
                  color: "#3d0e1e"
                },
                headerCalenderStyle: {
                  background: "#fff4e4"
                },
                footerStyle: {
                  height: "50px"
                },
                afterTodayStyle: {
                  color: "#eeeeee",
                  boxShadow: "inset 0 0 10px #311d3f",
                  background: "#88304e",
                  transition: "all 1s"
                },
                todayStyle: {
                  color: "#eeeeee",
                  background: "#522546",
                  boxShadow: "0 0 5px #eeeeee",
                  transition: " all 1s"
                },
                beforeTodayStyle: {
                  background: "#eeeeee",
                  boxShadow: "inset 0 0 10px #88304e",
                  color: "#88304e",
                  transition: "all 1s"
                }
              },moveAction: {
                  action: ""
                }
       }
      }
      render() {
        return (
          <div className="container">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative d-flex flex-column align-items-center">
                <InlineCalenderVertical
                showTitle={true}
                showFooter={false}
                useRaitoSizing={true}
                isFiveRow={true}
                moveAction={this.state.moveAction}
                headerCalenderItemStyle={this.state.e23.headerCalenderItemStyle}
                mainBodyStyle={this.state.e23.mainBodyStyle}
                titleStyle={this.state.e23.titleStyle}
                headerCalenderStyle={this.state.e23.headerCalenderStyle}
                />
                <div className="d-flex mt-3">
                <button
                    type="button"
                    className="btn btn-sm mx-2"
                    style={{ background: "#3d0e1e", color: "#fff4e4" }}
                    onClick={() => {
                    this.setState({ moveAction: { action: "p" } });
                    }}
                >
                    per
                </button>
                <button
                    style={{ background: "#3d0e1e", color: "#fff4e4" }}
                    className="btn mx-2 btn-sm"
                    onClick={() => {
                    this.setState({ moveAction: { action: "t" } });
                    }}
                >
                    today
                </button>
                <button
                    type="button"
                    style={{ background: "#3d0e1e", color: "#fff4e4" }}
                    className="btn mx-2 btn-sm"
                    onClick={() => {
                    this.setState({
                        moveAction: {
                        useJump: true,
                        jump: {
                            year: -1,
                            month: 2
                        }
                        }
                    });
                    }}
                >
                    > jump y:-1 <br />
                    m:2
                </button>
                <button
                    type="button"
                    style={{ background: "#3d0e1e", color: "#fff4e4" }}
                    className="btn mx-2 btn-sm"
                    onClick={() => {
                    this.setState({
                        moveAction: {
                        useJump: true,
                        jump: {
                            month: 5
                        }
                        }
                    });
                    }}
                >
                    jump m:5
                </button>
                <button
                    type="button"
                    style={{ background: "#3d0e1e", color: "#fff4e4" }}
                    className="btn mx-2 btn-sm"
                    onClick={() => {
                    this.setState({ moveAction: { action: "n" } });
                    }}
                >
                    next
                </button>
                </div>
            </div>
            </div>

          </div>
        );
      }
    }
     
    export default Sample;
    `;
    let ob9 = {
      enterAnimation: function() {
        $(".drawer .drawer-inside").addClass("animated bounceInDown fast");
        setTimeout(function() {
          $(".drawer .drawer-inside").removeClass("animated bounceInDown fast");
          $(".drawer .drawer-outside").css({
            background: "rgba(0, 0, 0, 0.3)"
          });
        }, 799);
      },
      exitAnimation: function() {
        $(".drawer").addClass("animated hinge fast");
        setTimeout(function() {
          clearDrawer("drawer");
        }, 799);
      }
    };
    let stringCode10 = `
    import React from "react";
    import "bootstrap/dist/css/bootstrap.css";
    import {
        FullCalender,
        FullCalenderVertical
    } from "react-inline-calender";
    class Sample extends React.Component {
      constructor(props) {
        super(props);
      }
      render() {
        return (
          <div className="container">
            <div className="row">
                <div className="col-6">
                    <FullCalender animUp="" animDown="" v-model="fValue" />
                </div>
                <div className="col-6">
                    <FullCalenderVertical animUp="" animDown="" v-model="fValue" />
                </div>
            </div>
          </div>
        );
      }
    }
     
    export default Sample;`;
    let ob10 = {
      exitResizeing: false,
      withNavItemBootstrap: false,
      withNavbarBrandBootstrap: false,
      withDropDownBotstrap: false,
      customJqueryElement: $(".nav .nav-item").clone(true),
      customHeadDrawer: "<div></div>",
      headerStyle: {},
      class: {
        showButton: "openDrawer"
      },
      defualtStylesPosition: 8
    };
    return (
      <div className="main bg-light" data-nav="2">
        <h2 id="b-0" className="mb-2">
          Examples
        </h2>

        <p>Here are some examples to get you started.</p>

        <h4 id="b-1">Simple calender</h4>
        <p>Simple with defualt style.</p>
        <div className="container  pb-3 border-bottom">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="container">
                <div className="row">
                  <div className="offset-3 col-6">
                    <InlineCalender />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                <CopyClip value={stringCode5}></CopyClip>
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode5}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h4 id="b-5" className="pt-3">
          Calender with 5 Row
        </h4>
        <p>Simple calender with 5 Row.</p>
        <div className="container   pb-3 border-bottom">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="container">
                <div className="row">
                  <div className="offset-3 col-6">
                    <InlineCalender isFiveRow={true} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                <CopyClip value={stringCode6}></CopyClip>
                {/* <PlayComponents optionDrawer={ob6}></PlayComponents> */}
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode6}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h4 id="b-2" className="pt-3">
          Custom Style Calender
        </h4>
        <p>you can customize calendar style.</p>
        <div className="container   pb-3 border-bottom">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="w-50">
                <InlineCalender
                  arrowLeftStyle={this.state.e1.arrowLeftColor}
                  arrowRightStyle={this.state.e1.arrowRightColor}
                  useRaitoSizing={false}
                  mainBodyStyle={this.state.e1.mainBodyStyle}
                  afterTodayStyle={this.state.e1.afterTodayStyle}
                  titleStyle={this.state.e1.titleStyle}
                  beforeTodayStyle={this.state.e1.beforeTodayStyle}
                  rowCalenderStyle={this.state.e1.rowCalenderStyle}
                  headerCalenderStyle={this.state.e1.headerCalenderStyle}
                  footerStyle={this.state.e1.footerStyle}
                  todayStyle={this.state.e1.todayStyle}
                  todayButtonStyle={this.state.e1.todayButtonStyle}
                  showSelectedValueStyle={this.state.e1.showSelectedValueStyle}
                />
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                {/* <svg className="clipbord-svg" data-codes="7" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard"   
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg> */}
                {/* <svg className="playsvg" id="i-play"
                                    title="" data-original-title="open drawer" data-placement="bottom"
                                      data-codes="7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <path d="M10 2 L10 30 24 16 Z" />
                                    </svg> */}
                {/* <textarea className="clipbordArea" data-codes="7" cols="auto" rows="auto"></textarea> */}
                <CopyClip value={stringCode7}></CopyClip>
                {/* <PlayComponents optionDrawer={ob7}></PlayComponents> */}
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode7}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h4 id="b-3" className="pt-3">
          Transparent calender
        </h4>
        <p>you can create transparent effect.</p>
        <div className="container    pb-3 border-bottom">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="w-50">
                <InlineCalender
                  useRaitoSizing={false}
                  arrowLeftStyle={this.state.e2.arrowLeftColor}
                  arrowRightStyle={this.state.e2.arrowRightColor}
                  mainBodyStyle={this.state.e2.mainBodyStyle}
                  afterTodayStyle={this.state.e2.afterTodayStyle}
                  titleStyle={this.state.e2.titleStyle}
                  beforeTodayStyle={this.state.e2.beforeTodayStyle}
                  rowCalenderStyle={this.state.e2.rowCalenderStyle}
                  headerCalenderStyle={this.state.e2.headerCalenderStyle}
                  footerStyle={this.state.e2.footerStyle}
                  todayStyle={this.state.e2.todayStyle}
                  todayButtonStyle={this.state.e2.todayButtonStyle}
                  showSelectedValueStyle={this.state.e2.showSelectedValueStyle}
                  headerCalenderItemStyle={
                    this.state.e2.headerCalenderItemStyle
                  }
                />
              </div>
            </div>
          </div>
          <div className="row ">
            <div
              className="col-12 col-code-keeper position-relative"
              style={{ padding: 0 }}
            >
              <div className="clipbord-keeper1">
                {/* <svg className="clipbord-svg" data-codes="8" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg> */}
                {/* <svg className="playsvg" id="i-play"
                                    title="" data-original-title="open drawer" data-placement="bottom"
                                      data-codes="8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <path d="M10 2 L10 30 24 16 Z" />
                                    </svg> */}
                <CopyClip value={stringCode8}></CopyClip>
                {/* <textarea className="clipbordArea" data-codes="8" cols="auto" rows="auto"></textarea> */}
                {/* <PlayComponents optionDrawer={ob8}></PlayComponents> */}
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode8}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h4 id="b-8" className="pt-3">
          Vertical calender
        </h4>
        <p>Use External buttons for change calendar.</p>
        <div className="container    pb-3 border-bottom">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative d-flex flex-column align-items-center">
              <InlineCalenderVertical
                showTitle={true}
                showFooter={false}
                useRaitoSizing={true}
                isFiveRow={true}
                moveAction={this.state.moveAction}
                headerCalenderItemStyle={this.state.e23.headerCalenderItemStyle}
                mainBodyStyle={this.state.e23.mainBodyStyle}
                titleStyle={this.state.e23.titleStyle}
                headerCalenderStyle={this.state.e23.headerCalenderStyle}
              />
              <div className="d-flex mt-3">
                <button
                  type="button"
                  className="btn btn-sm mx-2"
                  style={{ background: "#3d0e1e", color: "#fff4e4" }}
                  onClick={() => {
                    this.setState({ moveAction: { action: "p" } });
                  }}
                >
                  per
                </button>
                <button
                  style={{ background: "#3d0e1e", color: "#fff4e4" }}
                  className="btn mx-2 btn-sm"
                  onClick={() => {
                    this.setState({ moveAction: { action: "t" } });
                  }}
                >
                  today
                </button>
                <button
                  type="button"
                  style={{ background: "#3d0e1e", color: "#fff4e4" }}
                  className="btn mx-2 btn-sm"
                  onClick={() => {
                    this.setState({
                      moveAction: {
                        useJump: true,
                        jump: {
                          year: -1,
                          month: 2
                        }
                      }
                    });
                  }}
                >
                  jump y:-1 <br />
                  m:2
                </button>
                <button
                  type="button"
                  style={{ background: "#3d0e1e", color: "#fff4e4" }}
                  className="btn mx-2 btn-sm"
                  onClick={() => {
                    this.setState({
                      moveAction: {
                        useJump: true,
                        jump: {
                          month: 5
                        }
                      }
                    });
                  }}
                >
                  jump m:5
                </button>
                <button
                  type="button"
                  style={{ background: "#3d0e1e", color: "#fff4e4" }}
                  className="btn mx-2 btn-sm"
                  onClick={() => {
                    this.setState({ moveAction: { action: "n" } });
                  }}
                >
                  next
                </button>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                {/* <svg className="clipbord-svg" data-codes="9" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard" 
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg> */}
                <CopyClip value={stringCode9}></CopyClip>
                {/* <PlayComponents optionDrawer={ob9}></PlayComponents> */}
                {/* <svg className="playsvg" id="i-play"
                                    title="" data-original-title="open drawer" data-placement="bottom"
                                      data-codes="9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <path d="M10 2 L10 30 24 16 Z" />
                                    </svg> */}
                {/* <textarea className="clipbordArea" data-codes="9" cols="auto" rows="auto"></textarea> */}
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode9}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h4 id="b-9" className="pt-3">
          Full Calenders
        </h4>
        <p>Simple with defualt style.</p>
        <div className="container">
          <div className="row">
            <div className="col-6">
              <FullCalender animUp="" animDown="" v-model="fValue" />
            </div>
            <div className="col-6">
              <FullCalenderVertical animUp="" animDown="" v-model="fValue" />
            </div>
          </div>
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                {/* <svg className="clipbord-svg" data-codes="10" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg> */}
                {/* <svg className="playsvg" id="i-play"
                                    title="" data-original-title="open drawer" data-placement="bottom"
                                      data-codes="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <path d="M10 2 L10 30 24 16 Z" />
                                    </svg> */}
                <CopyClip value={stringCode10}></CopyClip>
                <PlayComponents optionDrawer={ob10}></PlayComponents>
                {/* <textarea className="clipbordArea" data-codes="10" cols="auto" rows="auto"></textarea> */}
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode10}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
